/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const MarkerType = {
    StartOfIncident: 'StartOfIncident',
    EndOfIncident: 'EndOfIncident',
    PointOfInterest: 'PointOfInterest'
};
export function MarkerTypeFromJSON(json) {
    return MarkerTypeFromJSONTyped(json, false);
}
export function MarkerTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function MarkerTypeToJSON(value) {
    return value;
}
